<template>
  <div>

     <b-modal size="xl" hide-footer v-model="view_modal_reservation" class="w-100" title="RESERVA">
        
        <b-tabs content-class="mt-3">
          <b-tab title="Reserva" active>
            <b-form @submit.prevent="Validation">
              <b-row>
                <b-col sm="2" md="2">
                    <b-form-group>
                      <label class="control-label">N° Reserva: </label>
                      <b-form-input disabled class="text-center" v-model="reservation.number"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="10" md="10">
                    <b-form-group>
                      <label class="control-label">Cliente: <span class="badge badge-primary link" @click="ShowModalClient">NUEVO</span></label>
                      <v-select placeholder="Seleccione un cliente" inputId="id" class="w-100" :filterable="false" label="full_name" v-model="client" @search="SearchClient" :options="clients"></v-select>
                      <small v-if="errors.id_client" class="form-text text-danger" >Seleccione un cliente</small>
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group label="Tipo de Habitación :">
                      <b-form-select v-model="reservation.id_type_room" @change="ListRoom" :options="type_room"></b-form-select>
                      <small v-if="errors.id_type_room" class="form-text text-danger" >Seleccione un tipo de habitación</small>
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group label="Habitación :">
                      <b-form-select v-model="reservation.id_room" @change="ViewRoom" :options="room"></b-form-select>
                      <small v-if="errors.id_room" class="form-text text-danger" >Seleccione una habitación</small>
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group label="Desde :">
                      <b-form-input @change="CalculateDays" :max="reservation.to" type="date" v-model="reservation.from" ></b-form-input>
                      <small v-if="errors.from" class="form-text text-danger" >Seleccione una fecha</small>
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group label="Hora :">
                      <b-form-input class="text-center" type="time" v-model="reservation.hour_from" ></b-form-input>
                      <small v-if="errors.hour_from" class="form-text text-danger" >Seleccione una hora</small>
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group label="Hasta :">
                      <b-form-input @change="CalculateDays" :min="reservation.from" type="date" v-model="reservation.to" ></b-form-input>
                      <small v-if="errors.to" class="form-text text-danger" >Seleccione una fecha</small>
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group label="Hora :">
                      <b-form-input class="text-center" type="time" v-model="reservation.hour_to" ></b-form-input>
                      <small v-if="errors.hour_to" class="form-text text-danger" >Seleccione una hora</small>
                    </b-form-group>
                  </b-col>


                  <b-col md="3">
                    <b-form-group label="Noches :">
                      <b-form-input disabled type="number" class="text-center" v-model="reservation.nights" ></b-form-input>
                      <small v-if="errors.nights" class="form-text text-danger" >Seleccione las fechas</small>
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="Precio :">
                      <b-form-input  type="number" @change="CalculateDays"  step="any" class="text-right" v-model="reservation.price" ></b-form-input>
                      <small v-if="errors.price" class="form-text text-danger" >Ingrese un precio</small>
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="Total :">
                      <b-form-input disabled type="number"  step="any" class="text-right" v-model="reservation.total" ></b-form-input>
                      <small v-if="errors.total" class="form-text text-danger" >Ingrese el monto total</small>
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="Medio de Reserva :">
                      <b-form-select v-model="reservation.reserve_medium" :options="reserve_medium"></b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group>
                      <label class="control-label">Observación:</label>
                      <b-form-textarea v-model="reservation.observation"></b-form-textarea>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group>
                      <b-button class="form-control btn-warning" @click="ViewPDF" type="button">IMPRIMIR FICHA</b-button>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <b-button class="form-control btn-danger" @click="ConfirmCancel" type="button">ANULAR RESERVA</b-button>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <b-button class="form-control btn-primary" type="submit">GUARDAR RESERVA</b-button>
                    </b-form-group>
                  </b-col>


              </b-row>
            </b-form>
          </b-tab>
          <b-tab title="Pagos">

            <b-form @submit.prevent="ValidateAddReservationPayment">
              <b-row>
                

         

                  <b-col sm="6" md="3">
                    <b-form-group>
                      <label class="control-label">Forma de Pago: </label>
                      <b-form-select v-model="reservation_payment.payment_type" :options="payment_type"></b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12" md="3">
                    <b-form-group>
                      <label class="control-label">Referencia: </label>
                      <b-form-input v-model="reservation_payment.reference" type="text"></b-form-input>                    
                    </b-form-group>
                  </b-col>

                  <b-col sm="6" md="2">
                    <b-form-group>
                      <label class="control-label">Moneda: </label>
                      <b-form-select v-model="reservation_payment.coin" :options="coins"></b-form-select>
                      <small v-if="errors.coin" class="form-text text-danger" >Seleccione una moneda</small>
                    </b-form-group>
                  </b-col>


                  <b-col sm="12" md="2">
                    <b-form-group>
                      <label class="control-label">Total: </label>
                      <b-form-input v-model="reservation_payment.total" class="text-right" type="number" step="any"></b-form-input> 
                      <small v-if="errors.total" class="form-text text-danger" >Ingrese un monto</small>                     
                    </b-form-group>
                  </b-col>

                  <b-col sm="12" md="2">
                    <b-form-group>
                      <label class="control-label">.</label>
                      <b-button class="form-control btn-primary" type="submit">PAGAR</b-button>
                                      
                    </b-form-group>
                  </b-col>

             
              </b-row>
            </b-form>

            <b-col md="12">
                        <div class="table-responsive mt-3">
                          <table class="table table-hover table-bordered">
                            <thead>
                              <tr>
                                <th width="5%" class="text-center">#</th>
                                <th width="35%" class="text-center">Medio de Pago</th>
                                <th width="30%" class="text-center">Referencia</th>
                                <th width="10%" class="text-center">Moneda</th>
                                <th width="10%" class="text-center">Total</th>
                                <th width="10%" class="text-center">Acciones</th>
                              </tr>
                            </thead>
                            <tbody v-for="(item, index) in reservation_payments" :key="index">
                              <tr>
                                  <td class="text-center">{{ index + 1 }}</td>
                                  <td class="text-center">{{ GetPaymentType(item.payment_type) }}</td>
                                  <td class="text-left">{{ item.reference }}</td>
                                  <td class="text-center">{{ item.coin }}</td>
                                  <td class="text-right">{{ item.total }}</td>
                                  <td class="text-center">
                                    <b-button type="button" @click="ConfirmDeleteReservationPayment(item.id_reservation_payment)" class="btn btn-sm btn-danger"><i class="fas fa-trash-alt"></i></b-button>
                                  </td>
                              </tr>
                                  
                            </tbody>
                          </table>
                        </div>
            </b-col>

          </b-tab>
        </b-tabs>


    </b-modal>


 

  </div>
</template>

<style >

</style>

<script>
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";

import EventBus from "@/assets/js/EventBus";
var moment = require("moment");


export default {
  name: "UsuarioList",
  components:{
    vSelect,
    Loading
  },
  data() {
    return {
      module:'Reservation',
      role: 3,
      view_modal_reservation:false,
      selectInfo: null,
      reservation:{
        id_reservation:'',
        id_client:'',
        number:'',
        id_type_room:'',
        id_room:'',
        hour_from:'',
        from:'',
        hour_to:'',
        to:'',
        nights:0,
        price:0,
        total:0,
        reserve_medium:'',
        observation:'',
        state:1,
        
      },
      reserve_medium:[
        {value:'',text:'-- Seleccione un medio ..'},
        {value:'Booking',text:'Booking'},
        {value:'Facebook',text:'Facebook'},
        {value:'Instagram',text:'Instagram'},
        {value:'WhatsApp',text:'WhatsApp'},
        {value:'Llamada',text:'Llamada'},
        {value:'Personal',text:'Personal'},
      ],
      payment_type:[
          {value:'',text:'-- Seleccione un tipo de pago --'},
          {value:'01-001',text:'Contado - Efectivo'},
            {value:'01-002',text:'Contado - Visa'},
            {value:'01-003',text:'Contado - Mastercard'},
            {value:'01-004',text:'Contado - American Express'},
            {value:'01-005',text:'Contado - Transferencia de Fondos'},
            {value:'03-000',text:'Crédito'},
      ],
      coins:[
        {value: 'PEN', text:'PEN'},
        {value: 'USD', text:'USD'},
        {value: 'CLP', text:'CLP'},
      ],
      reservation_payment: {
          id_reservation_payment:'',
          id_user:'',
          coin:'PEN',
          payment_type:'01-001',
          reference:'',
          observation:'',
          total:(0).toFixed(2),
          state:'1',
          number_to_letters : '',
      },

      reservation_payments:[],

      clients:[],
      client:{id:1,full_name: 'VENTA DEL DIA - 00000000'},

      type_room:[],
      room:[{value:'',text:'-- Seleccione una habitación'}],
      errors:{
          id_client:false,
          id_type_room:false,
          id_room:false,
          from:false,
          to:false,
          nights:false,
          price:false,
          total:false,
      },


    };

  },
  mounted() {
    
        EventBus.$on('ShowModalViewReservation', (id_reservation) => {
            this.view_modal_reservation = true;
            this.reservation.id_reservation = id_reservation;
            this.ViewReservation();
        });
        this.ListTypeRoom();
        
  },
  methods: {
      SearchClient,
      ListTypeRoom,
      ListRoom,
      ViewRoom,
      CalculateDays,
      ShowModalClient,
      ViewReservation,

      Validation,
      EditReservation,

      ConfirmCancel,
      Cancel,

      ValidateAddReservationPayment,
      AddReservationPayment,
      ConfirmDeleteReservationPayment,
      DeleteReservationPayment,
      GetPaymentType,

      ViewPDF,
      
  },


  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    user: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user;
    },
  },
};

function ViewPDF() {
  let me = this;
  let url_pdf = me.url_base + "reservation-pdf/"+this.reservation.id_reservation;
    
    window.open(url_pdf,'_blank');
}
function ShowModalClient() {
  EventBus.$emit('ModalClient');
}
function GetPaymentType(payment_type) {
  let data = '';
  switch (payment_type) {
    case '01-001': data = 'Contado - Efectivo'; break;
    case '01-002': data = 'Contado - Visa'; break;
    case '01-003': data = 'Contado - Mastercard'; break;
    case '01-004': data = 'Contado - American Express'; break;
    case '01-005': data = 'Contado - Transferencia de Fondos'; break;
    case '01-006': data = 'Contado - Deposito en Cuenta'; break;
    default:
      break;
  }
  return data;
         
}
function SearchClient(search) {
  let me = this;
  let url = this.url_base + "search-clients/" + search;
  if (search !== "") {
    axios({
      method: "GET",
      url: url,
    }).then(function (response) {
          me.clients = response.data;
    })
  }
}
function ListTypeRoom() {
  let me = this;
  let url = this.url_base + "active-type-room";
  axios({
    method: "GET",
    url: url,
  }).then(function (response) {
      me.type_room = [{value:'',text:'-- Seleccione un tipo de habitación'}];
      for (let index = 0; index < response.data.result.length; index++) {
        const element = response.data.result[index];
        me.type_room.push({value:element.id_type_room,text:element.name})
      }
      
  })
  
}
function ListRoom() {
  if (this.reservation.id_type_room.length == 0) {
    this.room = [{value:'',text:'-- Seleccione una habitación'}];
    this.reservation.id_room = '';
    this.reservation.price = (0).toFixed();
    this.CalculateDays();
    return false;
  }
  let me = this;
  let url = this.url_base + "active-room-by-type-room/"+this.reservation.id_type_room;
  axios({
    method: "GET",
    url: url,
  }).then(function (response) {
       me.room = [{value:'',text:'-- Seleccione una habitación'}];
      for (let index = 0; index < response.data.result.length; index++) {
        const element = response.data.result[index];
        me.room.push({value:element.id_room,text:element.room_number})
      }
  })
}
function ViewRoom() {
   if (this.reservation.id_room.length == 0) {
    this.reservation.price = (0).toFixed(2);
    return false;
  }
  let me = this;
  let url = this.url_base + "room/view/"+this.reservation.id_room;
  axios({
    method: "GET",
    url: url,
    headers: {token: this.token, module: this.module,role: this.role },
  }).then(function (response) {
      if (response.data.status == 200) {
        me.reservation.price = parseFloat(response.data.result.price).toFixed(2);
        me.CalculateDays();
      }
  })
}
function CalculateDays() {
    let date1 = moment(this.reservation.from);
    let date2 = moment(this.reservation.to);
    this.reservation.nights = date2.diff(date1, 'days');

    let total = parseFloat(this.reservation.nights) * parseFloat(this.reservation.price);

    this.reservation.price = parseFloat(this.reservation.price).toFixed(2);
    this.reservation.total = total.toFixed(2);
    

}

function ViewReservation() {

  let me = this;
  let url = this.url_base + "reservation/view/"+this.reservation.id_reservation;
  axios({
    method: "GET",
    url: url,
    headers: {token: this.token, module: this.module,role: this.role },
  }).then(function (response) {
      if (response.data.status == 200) {
          me.reservation.id_type_room = response.data.result.reservation.id_type_room;
          me.ListRoom();

          me.reservation.number = response.data.result.reservation.number;
          me.reservation.id_reservation = response.data.result.reservation.id_reservation;
          me.reservation.id_client = response.data.result.reservation.id_client;
          me.reservation.id_room = response.data.result.reservation.id_room;
          me.reservation.from = response.data.result.reservation.from;
          me.reservation.hour_from = response.data.result.reservation.hour_from;
          me.reservation.to = response.data.result.reservation.to;
          me.reservation.hour_to = response.data.result.reservation.hour_to;
          me.reservation.nights = response.data.result.reservation.nights;
          me.reservation.price = response.data.result.reservation.price;
          me.reservation.total = response.data.result.reservation.total;
          me.reservation.reserve_medium = response.data.result.reservation.reserve_medium;
          me.reservation.observation = response.data.result.reservation.observation;
          me.reservation.state = response.data.result.reservation.state;
          
          me.client = {id: response.data.result.reservation.id_client,full_name:response.data.result.reservation.name +' '+ response.data.result.reservation.document_number }


          me.reservation_payments = response.data.result.reservation_payments;
      }
  })
}
function EditReservation(_this) {

  let me = _this;
  me.reservation.id_user = me.user.id_user;
  me.reservation.id_client = me.client.id;
  let url = me.url_base + "reservation/edit";
  let data = me.reservation;
  
  axios({
    method: "PUT",
    url: url,
    data: data,
    headers: {
      "Content-Type": "application/json",
      token: me.token,
      module: me.module,
      role: me.role,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        Swal.fire({ icon: 'success', text: 'Se ha actualizado exitosamente la reserva',  timer: 3000,  })
        let info = {
          id: response.data.result.id_reservation,
          title: response.data.result.name_type_room + ' | '+ response.data.result.room_number+ ' | '+ response.data.result.name+ ' | '+ response.data.result.document_number,
          start: response.data.result.from,
          end: response.data.result.to,
          backgroundColor: '#000000',
        };
        EventBus.$emit('EditEventCalendar',info);
        me.view_modal_reservation = false;
      }else{
        Swal.fire({ icon: 'error', text: response.data.message,  timer: 3000,  })
      }
    })
    .catch((error) => {
      // Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
  
}


function Validation() {


  this.errors.id_client = this.client == null ? true : false;
  this.errors.id_type_room = this.reservation.id_type_room.length == 0 ? true : false;
  this.errors.id_room = this.reservation.id_room.length == 0 ? true : false;
  this.errors.from = this.reservation.from.length == 0 ? true : false;
  this.errors.to = this.reservation.to.length == 0 ? true : false;
  this.errors.nights = this.reservation.nights.length == 0 ? true : false;
  this.errors.price = this.reservation.price.length == 0 ? true : false;
  this.errors.total = this.reservation.total.length == 0 ? true : false;


  if (this.errors.id_client) { return false;}
  if (this.errors.id_type_room) { return false;}
  if (this.errors.id_room) { return false;}
  if (this.errors.from) { return false;}
  if (this.errors.to) { return false;}
  if (this.errors.nights) { return false;}
  if (this.errors.price) { return false;}
  if (this.errors.total) { return false;}


  let me = this;
  Swal.fire({
    title: 'Esta seguro de modificar la reserva?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si, Estoy de Acuerdo!'
  }).then((result) => {
    if (result.isConfirmed) {
      EditReservation(me);
    }
  })
}

function ConfirmCancel(id_reservation) {
  let me = this;
  Swal.fire({
    title: 'Esta seguro de anula la reserva?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si, Estoy de Acuerdo!'
  }).then((result) => {
    if (result.isConfirmed) {
      Cancel(me);
    }
  })
}

function Cancel(_this) {

  let me = _this;

  let url = me.url_base + "reservation/delete/"+me.reservation.id_reservation;

  
  axios({
    method: "DELETE",
    url: url,
    headers: {
      "Content-Type": "application/json",
      token: me.token,
      module: me.module,
      role: me.role,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        Swal.fire({ icon: 'success', text: 'Se ha anulado exitosamente la reserva',  timer: 3000,  })
        EventBus.$emit('DeleteEventCalendar',response.data.result.id_reservation);
        me.view_modal_reservation = false;
      }else{
        Swal.fire({ icon: 'error', text: response.data.message,  timer: 3000,  })
      }
    })
    .catch((error) => {
      // Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
  
}




function ValidateAddReservationPayment() {
  

  if (this.reservation_payment.payment_type.length == 0) {
    Swal.fire({ icon: 'warning', text: 'Seleccione una forma de pago',  timer: 2000,  })
    return false;
  }
  if (parseFloat(this.reservation_payment.total) <= 0 || this.reservation_payment.total.length == 0) {
    Swal.fire({ icon: 'warning', text: 'Ingrese un monto',  timer: 2000,  })
    return false;
  }
  let total = 0;
  for (var i = 0; i < this.reservation_payments.length; i++) {
      total += parseFloat(this.reservation_payments[i].total);
  }
  
  total += parseFloat(this.reservation_payment.total);
  console.log(total)
  if (parseFloat(this.reservation.total) < total) {
    Swal.fire({ icon: 'warning', text: 'El monto de la pago es superior a la reserva',  timer: 2000,  })
    return false;
  }

   Swal.fire({
    title: "Esta seguro de registrar el pago?",
    text: "No podrás revertir esto!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Estoy de acuerdo!",
  }).then((result) => {
    if (result.value) {
      this.AddReservationPayment(this);
    }
  });

}


function AddReservationPayment(_this) {
  
  let me = _this;
  let url = me.url_base + "reservation/add-reservation-payment";

  let data = {
    id_reservation : me.reservation.id_reservation,
    id_user : me.user.id_user,
    payment_type : me.reservation_payment.payment_type,
    reference : me.reservation_payment.reference,
    coin : me.reservation_payment.coin,
    total : parseFloat(me.reservation_payment.total).toFixed(2),
  };
  axios({
    method: "POST",
    url: url,
    data: data,
    headers: {
      "Content-Type": "application/json",
      token: me.token,
      module: me.module,
      role: me.role,
    },
  })
    .then(function (response) {
      if (response.data.status == 201) {
        
        me.reservation_payment.reference = "";
        me.reservation_payment.total = (0).toFixed(2);

        Swal.fire({ icon: 'success', text: 'Se ha registrado exitosamente el pago',  timer: 3000,  })
        me.reservation_payments.push(response.data.result);
      }else{
        Swal.fire({ icon: 'error', text: 'A ocurrido un error',  timer: 3000,  })
      }
    })
  
  
}

function ConfirmDeleteReservationPayment(id_reservation_payment) {
  Swal.fire({
    title: "Esta seguro de eliminar el pago?",
    text: "No podrás revertir esto!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Estoy de acuerdo!",
  }).then((result) => {
    if (result.value) {
      this.DeleteReservationPayment(id_reservation_payment);
    }
  });
}

function DeleteReservationPayment(id_reservation_payment) {
  let me = this;
  let url = this.url_base + "reservation/delete-reservation-payment/" + id_reservation_payment;
  axios({
    method: "delete",
    url: url,
    headers: {
      token: this.token,
      module: this.module,
      role: this.role,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        
        for (var i = 0; i < me.reservation_payments.length; i++) {
          if (me.reservation_payments[i].id_reservation_payment == id_reservation_payment) {
            me.reservation_payments.splice(i, 1);
            break;
          }
        }
      
        Swal.fire({ icon: 'success', text: 'Se ha eliminado el pago',  timer: 2000,  })
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error',  timer: 2000,  })
      }
    })
  


 
}


// permisos
function Permission(module_permission) {
  let user_permissions = window.localStorage.getItem("user_permissions");
  user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
  if (user_permissions.indexOf(module_permission) > -1) {
    return true;
  } else {
    return false;
  }
}
</script>
